// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","App_logo":"App_App_logo__17jvX","App-logo-spin":"App_App-logo-spin__1up6W","App_header":"App_App_header__am8Vg","App-link":"App_App-link__XPeK4"};